export class DiscountTimer {
    constructor() {
        this.timers = {};
        this.bindEvents();
    }

    bindEvents(){
        let
            $this = this;

        $this.init_sudden_discount_timer();
        $this.init_countdown_timer();
    }

    init_sudden_discount_timer(){
        let
            $this = this,
            url = window.location.href;

        $('.js-sudden-discount-timer').each(function () {

            $(this).countdown(new Date($(this).data('time') * 1000), function (event) {
                $(this).html(event.strftime('%H:%M:%S'));
            });

            $(this).on('finish.countdown', function(){
                let
                    discountId =  $(this).data('id'),
                    productId =  $(this).data('product-id');

                $.post('/ajax/discount/get_discount_accept_modal/' + discountId + '/' + productId, function(modal) {
                    $(modal).appendTo('body').modal();
                    let
                        $modal = $('.js-discount-accept-modal'),
                        $submit = $('.js-accept-discount', $modal),
                        $cancel = $('.js-complete-discount', $modal),
                        discountId = $modal.data('discount-id'),
                        productId = $modal.data('product-id');

                    $submit.on('click', function(event){
                        event.preventDefault();
                        $this.accept_discount(discountId, productId);
                        window.location.href = url;
                        $modal.modal('hide');
                        $modal.remove();
                    });

                    $cancel.on('click', function(event){
                        event.preventDefault();
                        $modal.modal('hide');
                        $modal.remove();
                        $this.complete_discount(discountId, false, true);
                    });

                    $modal.on('click', function(event){
                        if ($(event.target).hasClass('modal')){
                            $this.complete_discount(discountId, false, false);
                        }
                    });

                    $('.close', $modal).on('click', function(event){
                        $this.complete_discount(discountId, false, false);
                    });
                });
            });
        });
    }

    init_countdown_timer(){
        let
            $this = this,
            discountId,
            time,
            $timer;

        $('.js-countdown-timer').each(function () {
            if ($(this).attr('data-time') <= Date.now() / 1000){
                $(this).remove();
            } else {
                $this.init_timer($(this));
            }
        });

        for (discountId in $this.timers)
        {
            time = $this.timers[discountId];
            $timer = $('<div class="js-timer hidden" data-time="' + time + '" data-discount-id="' + discountId + '"></div>');

            $('body').append($timer);

            $timer.countdown(new Date(time * 1000), function (event) {
                $(this).html(event.strftime('%H:%M:%S'));
            });

            $timer.on('finish.countdown', function(){
                let
                    discountId =  $(this).data('discount-id');

                $.post('/ajax/discount/finish_timer/' + discountId,  {}, function(result){
                    if (result.action == 'complete')
                    {
                        $this.complete_discount(discountId, true, true);
                    }
                    else
                    {
                        $this.extend_discount_modal(discountId);
                    }
                }, 'json');
            });
        }
    }

    init_timer($timer){
        let
            // $timer = $(this),
            $this = this,
            discountId = $timer.data('discount-id'),
            time = $timer.attr('data-time'),
            date = new Date(time * 1000),
            $container = $('.countdown-timer__container', $timer),
            needHour = parseInt((time - Date.now() / 1000) / 60 / 60) > 0,
            timerTemplate = '';

        $this.timers[discountId] = time;

        if (needHour){
            timerTemplate += '<div class="countdown-timer__block">' +
                '<div class="countdown-timer__time">%H</div>' +
                '</div>' +
                ' : ';
        }

        timerTemplate += '<div class="countdown-timer__block">' +
            '<div class="countdown-timer__time">%M</div>' +
            '</div>' +
            ' : ' +
            '<div class="countdown-timer__block">' +
            '<div class="countdown-timer__time">%S</div>' +
            '</div>';

        $container.countdown(date, function (event) {
            $(this).html(event.strftime(timerTemplate));
        });
    }

    extend_discount_modal(discountId){
        let
            $this = this;

        $.post('/ajax/discount/get_discount_extension_modal/' + discountId, function(modal) {

            let
                $currentModal = $('body').find('.js-discount-extension-modal');

            if ($currentModal.length > 0 && parseInt($currentModal.data('discount-id')) == parseInt($(modal).data('discount-id'))){
                return;
            }

            $(modal).appendTo('body').modal();

            let
                $modal = $('.js-discount-extension-modal'),
                $submit = $('.js-extend-discount', $modal),
                $cancel = $('.js-complete-discount', $modal),
                discountId = $modal.data('discount-id');

            $submit.on('click', function(event){
                event.preventDefault();
                $this.extend_discount(discountId);
                $modal.modal('hide');
                $modal.remove();
            });

            $cancel.on('click', function(event){
                event.preventDefault();
                $modal.modal('hide');
                $modal.remove();
                $this.complete_discount(discountId, false, true);
            });

            $modal.on('click', function(event){
                if ($(event.target).hasClass('modal')){
                    $this.complete_discount(discountId, false, true);
                }
            });

            $('.close', $modal).on('click', function(event){
                $this.complete_discount(discountId, false, true);
            });
        });
    }

    extend_discount(discountId){
        let
            $this = this;

        $.post('/ajax/discount/extend_discount/' + discountId, function(result){
            let
                $timer = $('.js-countdown-timer[data-discount-id="' + discountId + '"]'),
                time = parseInt(Date.now()) / 1000 + parseInt(result.DISCOUNT_EXTENSION_TIME);

            $timer.each(function(){
                $(this).attr('data-time', parseInt(time));
            });

            $('.js-timer[data-discount-id="' + discountId + '"]').remove();

            $this.bindEvents();
        }, 'json');
    }

    complete_discount(discountId, showModal, reload){
        let
            url = window.location.href;

        $.post('/ajax/discount/complete_discount/' + discountId);

        if (showModal)
        {
            $.post('/ajax/discount/get_discount_complete_modal/' + discountId, function(modal) {
                $(modal).appendTo('body').modal();

                let
                    $modal = $('.js-discount-complete-modal'),
                    $submit = $('.js-complete-discount', $modal);

                $modal.on('hidden.bs.modal', function () {
                    window.location.href = url;
                });

                $submit.on('click', function(event){
                    event.preventDefault();
                    window.location.href = url;
                });
            });
        }
        else if (reload)
        {
            window.location.href = url;
        }
    }

    accept_discount(discountId, productId){
        $.post('/ajax/discount/accept_discount/' + discountId + '/' + productId, function(result){}, 'json');
    }
}
